export default {
  index: 'Home Page',
  logIn: 'Login',
  logOut: 'Log Out',
  profile: 'Personal Center',
  webcomeBack: 'Welcome',
  noName: 'No name yet'
}
